import { useEffect } from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import {
  loadTeamHierarchy,
  selectHierarchy,
  selectHierarchyLoadingStatus,
  userAppSelectors,
} from 'redux/slices/usersSlice.slice';
import { ensureTeamAllViewable } from 'redux/thunks/referenceData.thunk';
import { useAppDispatch, useAppSelector } from 'redux/storeHooks';
import Loader from '../../workflows/Loader';
import { ControlledSelect } from '@act/storybook';
import { MemberTransferRequestFormType } from '@act/shared/data-transfer-objects';

interface ControlledGuideSelectorProps {
  control: Control<MemberTransferRequestFormType>;
  errors: FieldErrors<MemberTransferRequestFormType>;
}

const ControlledGuideSelector = ({
  control,
  errors,
}: ControlledGuideSelectorProps) => {
  const dispatch = useAppDispatch();
  const hierarchyLoadingStatus = useAppSelector(selectHierarchyLoadingStatus);
  const teamHierarchy = useAppSelector(selectHierarchy);
  const viewableGuides = userAppSelectors.useSelectCurrentGuides();

  // Always dispatch ensure*; thunk skips when the all-viewable session cache is fresh.
  useEffect(() => {
    if (teamHierarchy?.length) {
      void dispatch(ensureTeamAllViewable());
    }
  }, [dispatch, teamHierarchy]);

  useEffect(() => {
    async function fetchTeamHierarchy() {
      await dispatch(await loadTeamHierarchy());
    }

    if (teamHierarchy === null && hierarchyLoadingStatus !== 'loading') {
      void fetchTeamHierarchy();
    }
  }, [dispatch, hierarchyLoadingStatus, teamHierarchy]);

  return (
    <div>
      {!viewableGuides?.length && <Loader />}
      {viewableGuides?.length && (
        <ControlledSelect
          defaultValue={null}
          control={control}
          errors={errors}
          name="receivingGuideId"
          label="Select a Guide"
          options={[...viewableGuides].map(user => {
            return { label: user.name, value: user.id };
          })}
          required
          fullWidth
        />
      )}
    </div>
  );
};

export default ControlledGuideSelector;
